export const poisWithDistances = [
  {
    name: "Woolwich Dockyard",
    category: "Connections",
    coordinates: {
      lat: 51.49116,
      lng: 0.05454,
    },
    distances: {
      DRIVING: {
        distance: "0.4 mi",
        duration: "2 mins",
      },
      BICYCLING: {
        distance: "0.4 mi",
        duration: "3 mins",
      },
      WALKING: {
        distance: "0.4 mi",
        duration: "10 mins",
      },
      TRANSIT: {
        distance: "0.5 mi",
        duration: "7 mins",
      },
    },
  },
  {
    name: "Woolwich Elizabeth Line",
    category: "Connections",
    coordinates: {
      lat: 51.49207,
      lng: 0.07054,
    },
    distances: {
      DRIVING: {
        distance: "1.5 mi",
        duration: "8 mins",
      },
      BICYCLING: {
        distance: "1.3 mi",
        duration: "9 mins",
      },
      WALKING: {
        distance: "1.2 mi",
        duration: "27 mins",
      },
      TRANSIT: {
        distance: "1.6 mi",
        duration: "16 mins",
      },
    },
  },
  {
    name: "Woolwich Arsenal",
    category: "Connections",
    coordinates: {
      lat: 51.49012,
      lng: 0.06896,
    },
    distances: {
      DRIVING: {
        distance: "1.7 mi",
        duration: "8 mins",
      },
      BICYCLING: {
        distance: "1.3 mi",
        duration: "8 mins",
      },
      WALKING: {
        distance: "1.1 mi",
        duration: "26 mins",
      },
      TRANSIT: {
        distance: "1.3 mi",
        duration: "12 mins",
      },
    },
  },
  {
    name: "London City Airport",
    category: "Connections",
    coordinates: {
      lat: 51.50494,
      lng: 0.04959,
    },
    distances: {
      DRIVING: {
        distance: "7.2 mi",
        duration: "26 mins",
      },
      BICYCLING: {
        distance: "2.3 mi",
        duration: "21 mins",
      },
      WALKING: {
        distance: "2.4 mi",
        duration: "54 mins",
      },
      TRANSIT: {
        distance: "3.8 mi",
        duration: "35 mins",
      },
    },
  },
  {
    name: "Woolwich Pier",
    category: "Connections",
    coordinates: {
      lat: 51.49533,
      lng: 0.06242,
    },
    distances: {
      DRIVING: {
        distance: "0.9 mi",
        duration: "5 mins",
      },
      BICYCLING: {
        distance: "1.4 mi",
        duration: "8 mins",
      },
      WALKING: {
        distance: "0.8 mi",
        duration: "19 mins",
      },
      TRANSIT: {
        distance: "0.9 mi",
        duration: "15 mins",
      },
    },
  },
  {
    name: "Greenwich Pantry",
    category: "Food and Beverage",
    coordinates: {
      lat: 51.49518,
      lng: 0.04461,
    },
    distances: {
      DRIVING: {
        distance: "0.6 mi",
        duration: "3 mins",
      },
      BICYCLING: {
        distance: "0.9 mi",
        duration: "5 mins",
      },
      WALKING: {
        distance: "0.6 mi",
        duration: "14 mins",
      },
      TRANSIT: {
        distance: "0.6 mi",
        duration: "14 mins",
      },
    },
  },
  {
    name: "Kailash Momo",
    category: "Food and Beverage",
    coordinates: {
      lat: 51.4891,
      lng: 0.06748,
    },
    distances: {
      DRIVING: {
        distance: "2.0 mi",
        duration: "9 mins",
      },
      BICYCLING: {
        distance: "1.3 mi",
        duration: "8 mins",
      },
      WALKING: {
        distance: "1.1 mi",
        duration: "26 mins",
      },
      TRANSIT: {
        distance: "1.4 mi",
        duration: "15 mins",
      },
    },
  },
  {
    name: "Dial Arch Pub",
    category: "Food and Beverage",
    coordinates: {
      lat: 51.49262,
      lng: 0.07015,
    },
    distances: {
      DRIVING: {
        distance: "2.4 mi",
        duration: "10 mins",
      },
      BICYCLING: {
        distance: "1.3 mi",
        duration: "8 mins",
      },
      WALKING: {
        distance: "1.2 mi",
        duration: "27 mins",
      },
      TRANSIT: {
        distance: "1.6 mi",
        duration: "16 mins",
      },
    },
  },
  {
    name: "McDonald's",
    category: "Food and Beverage",
    coordinates: {
      lat: 51.49292,
      lng: 0.04635,
    },
    distances: {
      DRIVING: {
        distance: "0.6 mi",
        duration: "3 mins",
      },
      BICYCLING: {
        distance: "0.6 mi",
        duration: "4 mins",
      },
      WALKING: {
        distance: "0.5 mi",
        duration: "11 mins",
      },
      TRANSIT: {
        distance: "0.5 mi",
        duration: "11 mins",
      },
    },
  },
  {
    name: "SALT Woolwich",
    category: "Food and Beverage",
    coordinates: {
      lat: 51.49244,
      lng: 0.07166,
    },
    distances: {
      DRIVING: {
        distance: "1.5 mi",
        duration: "8 mins",
      },
      BICYCLING: {
        distance: "1.4 mi",
        duration: "9 mins",
      },
      WALKING: {
        distance: "1.3 mi",
        duration: "28 mins",
      },
      TRANSIT: {
        distance: "1.7 mi",
        duration: "17 mins",
      },
    },
  },
  {
    name: "Gail's Bakery",
    category: "Food and Beverage",
    coordinates: {
      lat: 51.49221,
      lng: 0.07072,
    },
    distances: {
      DRIVING: {
        distance: "1.5 mi",
        duration: "8 mins",
      },
      BICYCLING: {
        distance: "1.3 mi",
        duration: "9 mins",
      },
      WALKING: {
        distance: "1.2 mi",
        duration: "28 mins",
      },
      TRANSIT: {
        distance: "1.6 mi",
        duration: "16 mins",
      },
    },
  },
  {
    name: "Mayron Park",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.48956,
      lng: 0.04445,
    },
    distances: {
      DRIVING: {
        distance: "0.2 mi",
        duration: "1 min",
      },
      BICYCLING: {
        distance: "0.2 mi",
        duration: "1 min",
      },
      WALKING: {
        distance: "0.2 mi",
        duration: "5 mins",
      },
      TRANSIT: {
        distance: "0.2 mi",
        duration: "5 mins",
      },
    },
  },
  {
    name: "Maryon Wilson Animal Park",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.48657,
      lng: 0.04382,
    },
    distances: {
      DRIVING: {
        distance: "0.3 mi",
        duration: "1 min",
      },
      BICYCLING: {
        distance: "0.4 mi",
        duration: "3 mins",
      },
      WALKING: {
        distance: "0.4 mi",
        duration: "9 mins",
      },
      TRANSIT: {
        distance: "0.4 mi",
        duration: "9 mins",
      },
    },
  },
  {
    name: "Woolwich Common",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.47959,
      lng: 0.06017,
    },
    distances: {
      DRIVING: {
        distance: "1.8 mi",
        duration: "7 mins",
      },
      BICYCLING: {
        distance: "1.4 mi",
        duration: "11 mins",
      },
      WALKING: {
        distance: "1.3 mi",
        duration: "30 mins",
      },
      TRANSIT: {
        distance: "2.1 mi",
        duration: "25 mins",
      },
    },
  },
  {
    name: "Waterfront Leisure Centre",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.49425,
      lng: 0.06383,
    },
    distances: {
      DRIVING: {
        distance: "0.9 mi",
        duration: "4 mins",
      },
      BICYCLING: {
        distance: "1.0 mi",
        duration: "7 mins",
      },
      WALKING: {
        distance: "0.9 mi",
        duration: "20 mins",
      },
      TRANSIT: {
        distance: "1.0 mi",
        duration: "16 mins",
      },
    },
  },
  {
    name: "The Reach Climbing Wall",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.49446,
      lng: 0.04376,
    },
    distances: {
      WALKING: {
        distance: "0.6 mi",
        duration: "14 mins",
      },
      DRIVING: {
        distance: "0.6 mi",
        duration: "3 mins",
      },
      BICYCLING: {
        distance: "0.6 mi",
        duration: "4 mins",
      },
      TRANSIT: {
        distance: "0.6 mi",
        duration: "14 mins",
      },
    },
  },
  {
    name: "The Yoga Space London",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.49478,
      lng: 0.06676,
    },
    distances: {
      WALKING: {
        distance: "1.0 mi",
        duration: "23 mins",
      },
      DRIVING: {
        distance: "1.0 mi",
        duration: "5 mins",
      },
      BICYCLING: {
        distance: "1.1 mi",
        duration: "7 mins",
      },
      TRANSIT: {
        distance: "1.9 mi",
        duration: "22 mins",
      },
    },
  },
  {
    name: "Charlton Lido and Lifestyle Club",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.47543,
      lng: 0.03963,
    },
    distances: {
      WALKING: {
        distance: "1.3 mi",
        duration: "32 mins",
      },
      DRIVING: {
        distance: "1.4 mi",
        duration: "7 mins",
      },
      BICYCLING: {
        distance: "1.4 mi",
        duration: "11 mins",
      },
      TRANSIT: {
        distance: "1.3 mi",
        duration: "18 mins",
      },
    },
  },
  {
    name: "PureGym",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.49142,
      lng: 0.07294,
    },
    distances: {
      WALKING: {
        distance: "1.3 mi",
        duration: "30 mins",
      },
      DRIVING: {
        distance: "1.4 mi",
        duration: "6 mins",
      },
      BICYCLING: {
        distance: "1.4 mi",
        duration: "9 mins",
      },
      TRANSIT: {
        distance: "2.0 mi",
        duration: "19 mins",
      },
    },
  },
  {
    name: "Greenwich Peninsula Golf Range",
    category: "Wellness and Leisure",
    coordinates: {
      lat: 51.49814,
      lng: 0.00098,
    },
    distances: {
      WALKING: {
        distance: "3.0 mi",
        duration: "1 hour 6 mins",
      },
      DRIVING: {
        distance: "2.9 mi",
        duration: "12 mins",
      },
      BICYCLING: {
        distance: "3.6 mi",
        duration: "18 mins",
      },
      TRANSIT: {
        distance: "3.9 mi",
        duration: "40 mins",
      },
    },
  },
  {
    name: "London Sculpture Workshop",
    category: "Arts and Culture",
    coordinates: {
      lat: 51.49527,
      lng: 0.04267,
    },
    distances: {
      WALKING: {
        distance: "0.7 mi",
        duration: "16 mins",
      },
      DRIVING: {
        distance: "0.7 mi",
        duration: "4 mins",
      },
      BICYCLING: {
        distance: "0.7 mi",
        duration: "4 mins",
      },
      TRANSIT: {
        distance: "0.7 mi",
        duration: "16 mins",
      },
    },
  },
  {
    name: "Woolwich Works",
    category: "Arts and Culture",
    coordinates: {
      lat: 51.49448,
      lng: 0.07052,
    },
    distances: {
      WALKING: {
        distance: "1.2 mi",
        duration: "27 mins",
      },
      DRIVING: {
        distance: "2.4 mi",
        duration: "11 mins",
      },
      BICYCLING: {
        distance: "1.3 mi",
        duration: "8 mins",
      },
      TRANSIT: {
        distance: "1.8 mi",
        duration: "19 mins",
      },
    },
  },
  {
    name: "Punchdrunk",
    category: "Arts and Culture",
    coordinates: {
      lat: 51.49379,
      lng: 0.0715,
    },
    distances: {
      WALKING: {
        distance: "1.2 mi",
        duration: "28 mins",
      },
      DRIVING: {
        distance: "2.4 mi",
        duration: "10 mins",
      },
      BICYCLING: {
        distance: "1.4 mi",
        duration: "8 mins",
      },
      TRANSIT: {
        distance: "1.8 mi",
        duration: "21 mins",
      },
    },
  },
  {
    name: "Magazine London",
    category: "Arts and Culture",
    coordinates: {
      lat: 51.50094,
      lng: -0.00053,
    },
    distances: {
      WALKING: {
        distance: "2.8 mi",
        duration: "1 hour 0 mins",
      },
      DRIVING: {
        distance: "3.0 mi",
        duration: "12 mins",
      },
      BICYCLING: {
        distance: "2.9 mi",
        duration: "14 mins",
      },
      TRANSIT: {
        distance: "3.5 mi",
        duration: "30 mins",
      },
    },
  },
  {
    name: "Busy Bees at Greenwich",
    category: "Education",
    coordinates: {
      lat: 51.49397,
      lng: 0.05095,
    },
    distances: {
      WALKING: {
        distance: "0.5 mi",
        duration: "12 mins",
      },
      DRIVING: {
        distance: "0.6 mi",
        duration: "4 mins",
      },
      BICYCLING: {
        distance: "0.6 mi",
        duration: "4 mins",
      },
      TRANSIT: {
        distance: "0.7 mi",
        duration: "10 mins",
      },
    },
  },
  {
    name: "Bear Hugs Day Nursery Sandy Hill",
    category: "Education",
    coordinates: {
      lat: 51.48375,
      lng: 0.06998,
    },
    distances: {
      WALKING: {
        distance: "1.4 mi",
        duration: "34 mins",
      },
      DRIVING: {
        distance: "2.0 mi",
        duration: "8 mins",
      },
      BICYCLING: {
        distance: "1.7 mi",
        duration: "13 mins",
      },
      TRANSIT: {
        distance: "1.6 mi",
        duration: "24 mins",
      },
    },
  },
  {
    name: "Windrush Primary School",
    category: "Education",
    coordinates: {
      lat: 51.49195,
      lng: 0.04277,
    },
    distances: {
      WALKING: {
        distance: "0.7 mi",
        duration: "15 mins",
      },
      DRIVING: {
        distance: "0.7 mi",
        duration: "3 mins",
      },
      BICYCLING: {
        distance: "0.7 mi",
        duration: "5 mins",
      },
      TRANSIT: {
        distance: "0.7 mi",
        duration: "15 mins",
      },
    },
  },
  {
    name: "Thorntree Primary School",
    category: "Education",
    coordinates: {
      lat: 51.48682,
      lng: 0.04208,
    },
    distances: {
      WALKING: {
        distance: "0.4 mi",
        duration: "9 mins",
      },
      DRIVING: {
        distance: "0.4 mi",
        duration: "2 mins",
      },
      BICYCLING: {
        distance: "0.4 mi",
        duration: "3 mins",
      },
      TRANSIT: {
        distance: "0.5 mi",
        duration: "4 mins",
      },
    },
  },
  {
    name: "Mulgrave Primary School",
    category: "Education",
    coordinates: {
      lat: 51.48871,
      lng: 0.06142,
    },
    distances: {
      WALKING: {
        distance: "0.8 mi",
        duration: "19 mins",
      },
      DRIVING: {
        distance: "1.1 mi",
        duration: "5 mins",
      },
      BICYCLING: {
        distance: "0.9 mi",
        duration: "6 mins",
      },
      TRANSIT: {
        distance: "1.0 mi",
        duration: "14 mins",
      },
    },
  },
  {
    name: "Woodhill Primary School",
    category: "Education",
    coordinates: {
      lat: 51.48942,
      lng: 0.04817,
    },
    distances: {
      WALKING: {
        distance: "0.2 mi",
        duration: "4 mins",
      },
      DRIVING: {
        distance: "0.2 mi",
        duration: "2 mins",
      },
      BICYCLING: {
        distance: "0.2 mi",
        duration: "1 min",
      },
      TRANSIT: {
        distance: "0.2 mi",
        duration: "4 mins",
      },
    },
  },
  {
    name: "St Mary Magdalene Primary School",
    category: "Education",
    coordinates: {
      lat: 51.49166,
      lng: 0.06207,
    },
    distances: {
      WALKING: {
        distance: "0.8 mi",
        duration: "18 mins",
      },
      BICYCLING: {
        distance: "0.8 mi",
        duration: "5 mins",
      },
      DRIVING: {
        distance: "1.0 mi",
        duration: "4 mins",
      },
      TRANSIT: {
        distance: "1.3 mi",
        duration: "14 mins",
      },
    },
  },
  {
    name: "Leigh Academy Blackheath",
    category: "Education",
    coordinates: {
      lat: 51.47593,
      lng: 0.02817,
    },
    distances: {
      WALKING: {
        distance: "1.6 mi",
        duration: "39 mins",
      },
      BICYCLING: {
        distance: "1.9 mi",
        duration: "13 mins",
      },
      DRIVING: {
        distance: "1.7 mi",
        duration: "7 mins",
      },
      TRANSIT: {
        distance: "2.7 mi",
        duration: "24 mins",
      },
    },
  },
  {
    name: "Townley Grammar School",
    category: "Education",
    coordinates: {
      lat: 51.45068,
      lng: 0.14144,
    },
    distances: {
      WALKING: {
        distance: "5.9 mi",
        duration: "2 hours 15 mins",
      },
      BICYCLING: {
        distance: "6.6 mi",
        duration: "40 mins",
      },
      DRIVING: {
        distance: "7.9 mi",
        duration: "17 mins",
      },
      TRANSIT: {
        distance: "6.6 mi",
        duration: "59 mins",
      },
    },
  },
  {
    name: "Blackheath High School ",
    category: "Education",
    coordinates: {
      lat: 51.47799,
      lng: 0.01681,
    },
    distances: {
      WALKING: {
        distance: "1.9 mi",
        duration: "45 mins",
      },
      BICYCLING: {
        distance: "2.1 mi",
        duration: "14 mins",
      },
      DRIVING: {
        distance: "2.0 mi",
        duration: "8 mins",
      },
      TRANSIT: {
        distance: "2.8 mi",
        duration: "18 mins",
      },
    },
  },
  {
    name: "The Pointer School",
    category: "Education",
    coordinates: {
      lat: 51.47493,
      lng: 0.01823,
    },
    distances: {
      WALKING: {
        distance: "2.0 mi",
        duration: "47 mins",
      },
      BICYCLING: {
        distance: "2.1 mi",
        duration: "14 mins",
      },
      DRIVING: {
        distance: "2.0 mi",
        duration: "9 mins",
      },
      TRANSIT: {
        distance: "2.7 mi",
        duration: "18 mins",
      },
    },
  },
  {
    name: "University of Greenwich",
    category: "Further Education",
    coordinates: {
      lat: 51.4831,
      lng: -0.00589,
    },
    distances: {
      WALKING: {
        distance: "2.7 mi",
        duration: "1 hour 0 mins",
      },
      BICYCLING: {
        distance: "2.9 mi",
        duration: "16 mins",
      },
      DRIVING: {
        distance: "3.3 mi",
        duration: "16 mins",
      },
      TRANSIT: {
        distance: "2.8 mi",
        duration: "28 mins",
      },
    },
  },
  {
    name: "University of East London",
    category: "Further Education",
    coordinates: {
      lat: 51.50772,
      lng: 0.06554,
    },
    distances: {
      WALKING: {
        distance: "2.5 mi",
        duration: "58 mins",
      },
      BICYCLING: {
        distance: "2.5 mi",
        duration: "22 mins",
      },
      DRIVING: {
        distance: "8.6 mi",
        duration: "29 mins",
      },
      TRANSIT: {
        distance: "4.1 mi",
        duration: "49 mins",
      },
    },
  },
  {
    name: "University of arts London",
    category: "Further Education",
    coordinates: {
      lat: 51.54178,
      lng: -0.01266,
    },
    distances: {
      WALKING: {
        distance: "6.8 mi",
        duration: "2 hours 35 mins",
      },
      BICYCLING: {
        distance: "8.6 mi",
        duration: "52 mins",
      },
      DRIVING: {
        distance: "6.5 mi",
        duration: "24 mins",
      },
      TRANSIT: {
        distance: "8.2 mi",
        duration: "56 mins",
      },
    },
  },
  {
    name: "The Woolwich College",
    category: "Further Education",
    coordinates: {
      lat: 51.49201,
      lng: 0.0644,
    },
    distances: {
      WALKING: {
        distance: "0.9 mi",
        duration: "21 mins",
      },
      BICYCLING: {
        distance: "1.1 mi",
        duration: "6 mins",
      },
      DRIVING: {
        distance: "1.3 mi",
        duration: "7 mins",
      },
      TRANSIT: {
        distance: "1.4 mi",
        duration: "15 mins",
      },
    },
  },
  {
    name: "UCL School of Management",
    category: "Further Education",
    coordinates: {
      lat: 51.50617,
      lng: -0.01152,
    },
    distances: {
      WALKING: {
        distance: "4.8 mi",
        duration: "1 hour 47 mins",
      },
      BICYCLING: {
        distance: "5.1 mi",
        duration: "34 mins",
      },
      DRIVING: {
        distance: "4.6 mi",
        duration: "18 mins",
      },
      TRANSIT: {
        distance: "6.7 mi",
        duration: "43 mins",
      },
    },
  },
  {
    name: "Goldsmiths University",
    category: "Further Education",
    coordinates: {
      lat: 51.4757,
      lng: -0.03964,
    },
    distances: {
      WALKING: {
        distance: "4.4 mi",
        duration: "1 hour 38 mins",
      },
      BICYCLING: {
        distance: "4.4 mi",
        duration: "24 mins",
      },
      DRIVING: {
        distance: "4.6 mi",
        duration: "20 mins",
      },
      TRANSIT: {
        distance: "4.6 mi",
        duration: "41 mins",
      },
    },
  },
  {
    name: "Mini Market, Post Office Maryon Road",
    category: "Amenities",
    coordinates: {
      lat: 51.48777,
      lng: 0.04996,
    },
    distances: {
      WALKING: {
        distance: "0.3 mi",
        duration: "6 mins",
      },
      BICYCLING: {
        distance: "0.3 mi",
        duration: "2 mins",
      },
      DRIVING: {
        distance: "0.4 mi",
        duration: "2 mins",
      },
      TRANSIT: {
        distance: "0.3 mi",
        duration: "6 mins",
      },
    },
  },
  {
    name: "Sainsbury's",
    category: "Amenities",
    coordinates: {
      lat: 51.49112,
      lng: 0.06401,
    },
    distances: {
      WALKING: {
        distance: "0.9 mi",
        duration: "20 mins",
      },
      BICYCLING: {
        distance: "0.9 mi",
        duration: "6 mins",
      },
      DRIVING: {
        distance: "1.2 mi",
        duration: "6 mins",
      },
      TRANSIT: {
        distance: "1.3 mi",
        duration: "13 mins",
      },
    },
  },
  {
    name: "Lidl",
    category: "Amenities",
    coordinates: {
      lat: 51.49251,
      lng: 0.06627,
    },
    distances: {
      WALKING: {
        distance: "1.0 mi",
        duration: "23 mins",
      },
      BICYCLING: {
        distance: "1.2 mi",
        duration: "7 mins",
      },
      DRIVING: {
        distance: "1.1 mi",
        duration: "5 mins",
      },
      TRANSIT: {
        distance: "1.4 mi",
        duration: "16 mins",
      },
    },
  },
  {
    name: "Tesco Express",
    category: "Amenities",
    coordinates: {
      lat: 51.49266,
      lng: 0.07186,
    },
    distances: {
      WALKING: {
        distance: "1.3 mi",
        duration: "29 mins",
      },
      BICYCLING: {
        distance: "1.4 mi",
        duration: "9 mins",
      },
      DRIVING: {
        distance: "2.3 mi",
        duration: "10 mins",
      },
      TRANSIT: {
        distance: "1.7 mi",
        duration: "17 mins",
      },
    },
  },
  {
    name: "Queen Elizabeth Hospital",
    category: "Amenities",
    coordinates: {
      lat: 51.47791,
      lng: 0.05012,
    },
    distances: {
      DRIVING: {
        distance: "1.5 mi",
        duration: "6 mins",
      },
      WALKING: {
        distance: "1.5 mi",
        duration: "34 mins",
      },
      BICYCLING: {
        distance: "1.6 mi",
        duration: "11 mins",
      },
      TRANSIT: {
        distance: "1.7 mi",
        duration: "24 mins",
      },
    },
  },
  {
    name: "IKEA",
    category: "Amenities",
    coordinates: {
      lat: 51.48992,
      lng: 0.01664,
    },
    distances: {
      DRIVING: {
        distance: "2.0 mi",
        duration: "9 mins",
      },
      WALKING: {
        distance: "1.8 mi",
        duration: "39 mins",
      },
      BICYCLING: {
        distance: "2.1 mi",
        duration: "12 mins",
      },
      TRANSIT: {
        distance: "2.2 mi",
        duration: "22 mins",
      },
    },
  },
  {
    name: "NS Warwick Pharmacy",
    category: "Amenities",
    coordinates: {
      lat: 51.49257,
      lng: 0.05636,
    },
    distances: {
      DRIVING: {
        distance: "0.6 mi",
        duration: "3 mins",
      },
      WALKING: {
        distance: "0.5 mi",
        duration: "12 mins",
      },
      BICYCLING: {
        distance: "0.5 mi",
        duration: "3 mins",
      },
      TRANSIT: {
        distance: "0.6 mi",
        duration: "9 mins",
      },
    },
  },
  {
    name: "The O2",
    category: "Destinations",
    coordinates: {
      lat: 51.50323,
      lng: 0.00389,
    },
    distances: {
      DRIVING: {
        distance: "3.4 mi",
        duration: "14 mins",
      },
      WALKING: {
        distance: "2.6 mi",
        duration: "56 mins",
      },
      BICYCLING: {
        distance: "2.6 mi",
        duration: "13 mins",
      },
      TRANSIT: {
        distance: "3.7 mi",
        duration: "35 mins",
      },
    },
  },
  {
    name: "Canary Wharf",
    category: "Destinations",
    coordinates: {
      lat: 51.50547,
      lng: -0.02309,
    },
    distances: {
      DRIVING: {
        distance: "5.2 mi",
        duration: "22 mins",
      },
      WALKING: {
        distance: "5.0 mi",
        duration: "1 hour 51 mins",
      },
      BICYCLING: {
        distance: "5.3 mi",
        duration: "35 mins",
      },
      TRANSIT: {
        distance: "6.3 mi",
        duration: "38 mins",
      },
    },
  },
  {
    name: "The Thames Barrier",
    category: "Destinations",
    coordinates: {
      lat: 51.49462,
      lng: 0.03826,
    },
    distances: {
      DRIVING: {
        distance: "1.2 mi",
        duration: "5 mins",
      },
      WALKING: {
        distance: "0.8 mi",
        duration: "17 mins",
      },
      BICYCLING: {
        distance: "0.8 mi",
        duration: "5 mins",
      },
      TRANSIT: {
        distance: "0.8 mi",
        duration: "17 mins",
      },
    },
  },
  {
    name: "Royal Albert Dock",
    category: "Destinations",
    coordinates: {
      lat: 51.50792,
      lng: 0.05323,
    },
    distances: {
      DRIVING: {
        distance: "7.3 mi",
        duration: "26 mins",
      },
      WALKING: {
        distance: "3.1 mi",
        duration: "1 hour 11 mins",
      },
      BICYCLING: {
        distance: "3.4 mi",
        duration: "27 mins",
      },
      TRANSIT: {
        distance: "5.5 mi",
        duration: "46 mins",
      },
    },
  },
  {
    name: "Greenwich Market",
    category: "Destinations",
    coordinates: {
      lat: 51.48169,
      lng: -0.00874,
    },
    distances: {
      DRIVING: {
        distance: "3.2 mi",
        duration: "15 mins",
      },
      WALKING: {
        distance: "2.8 mi",
        duration: "1 hour 2 mins",
      },
      BICYCLING: {
        distance: "2.8 mi",
        duration: "16 mins",
      },
      TRANSIT: {
        distance: "2.9 mi",
        duration: "27 mins",
      },
    },
  },
];
